<template>
  <div class="page_box">
    <div class="page_table_box" style="height:calc(100% - 10px)">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column fixed label="序号" align="center" width="70">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>

          <el-table-column
            prop="title"
            label="任务名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="startTime"
            label="开始时间"
            align="center"
            width="180"
          >
            <template v-slot="rowData">
              {{ $Common.dateFormatDate(rowData.row.startTime) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="endTime"
            label="结束时间"
            align="center"
            width="180"
          >
            <template v-slot="rowData">
              {{ $Common.dateFormatDate(rowData.row.endTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="检查人"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column label="任务状态" align="center" width="120">
            <template v-slot="scope">
              {{
                $store.state.select.specialTaskStatus[scope.row.status].nameOne
              }}
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="180">
            <template v-slot="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="getDetailsData(scope.row.id)"
                >预览</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="pagination_box"
      >
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="responseData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 详情 -->
    <el-dialog
      class="detail-dialog"
      title="详情内容"
      :visible.sync="dialogTableVisible"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <div style="height:470px">
        <div
          style="display: flex;justify-content:center;font-size:20px;font-weight: 600;"
        >
          <span>{{ inspectionDetails.title }}</span>
        </div>
        <span style="margin-left:20px;"
          >检查对象：{{ inspectionDetails.schoolName }}</span
        >
        <span
          style="float:right;margin-right:20px;"
          v-if="
            inspectionDetails.status == 1 ||
              inspectionDetails.status == 3 ||
              inspectionDetails.status == 4
          "
        >
          检查时间：{{ $Common.dateFormatDateTwo(inspectionDetails.addTime) }}
        </span>
        <span style="float:right;margin-right:120px;" v-else>
          检查时间：
        </span>
        <div style="max-height:400px;overflow:scroll">
          <el-table :data="inspectionDetails.schoolChecksList">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column
              property="projectName"
              label="项目名称"
              width="200"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              property="standardName"
              label="检查标准"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              label="自查结果"
              show-overflow-tooltip
              width="100px"
            >
              <template slot-scope="scope">
                <el-select
                  v-if="inspectionDetails.status == 0"
                  v-model="scope.row.internalState"
                  placeholder="请选择自查结果"
                  size="small"
                >
                  <el-option
                    v-for="item in stateListTwo"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <span v-else>
                  {{ stateList[scope.row.internalState].name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="小组结果"
              show-overflow-tooltip
              v-if="inspectionDetails.status != 0"
              width="100px"
            >
              <template slot-scope="scope">
                <el-select
                  v-if="inspectionDetails.status == 1 && isEdit"
                  v-model="scope.row.teamState"
                  placeholder="请选择小组结果"
                  size="small"
                >
                  <el-option
                    v-for="item in stateListTwo"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <span v-else>
                  {{ stateList[scope.row.teamState].name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="督查结果"
              show-overflow-tooltip
              v-if="inspectionDetails.status != 0"
              width="100px"
            >
              <template slot-scope="scope">
                <span>
                  {{ stateList[scope.row.inspectorState].name }}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin:20px;font-size:18px;font-weight: 600;">
            流水记录
          </div>
          <el-timeline
            :reverse="true"
            v-if="
              inspectionDetails.schoolRecordList &&
                inspectionDetails.schoolRecordList.length > 0
            "
          >
            <el-timeline-item
              v-for="(item, index) in inspectionDetails.schoolRecordList"
              :key="index"
              :timestamp="$Common.dateFormatDateTwo(item.addTime)"
            >
              {{ item.operater }}({{ operaterTypeList[item.type].name }}){{
                operaterResultList[item.type].name
              }}
            </el-timeline-item>
          </el-timeline>
          <span v-else style="display: flex;justify-content:center;"
            >暂无流水记录</span
          >
        </div>
        <el-button
          type="primary"
          style="float:right;margin-right:20px"
          size="small"
          :disabled="
            inspectionDetails.schoolChecksList.length > 0 ? false : true
          "
          v-if="inspectionDetails.status == 0"
          @click="saveClick"
        >
          检查
        </el-button>
        <el-button
          type="primary"
          style="float:right;margin-right:20px"
          size="small"
          v-if="inspectionDetails.status == 1 && isEdit"
          @click="saveClick"
        >
          审核
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      dialogTableVisible: false,
      requestData: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1
      },
      responseData: {
        pageNum: 1, // 第几页
        pageSize: 20, // 一页多少个
        total: 0, // 总条数
        pages: 0, // 总页数
        list: [] // 数据列表
      },

      // 详情数据
      detailsData: {
        projectInfo: [],
        contentInfo: {
          id: "",
          content: ""
        }
      },

      inspectionDetails: {},
      isEdit: false
    };
  },
  watch: {},
  computed: {
    //   检查结果类型
    stateList() {
      return [
        { id: 0, name: "没有检查" },
        { id: 1, name: "不符合" },
        { id: 2, name: "符合" }
      ];
    },
    stateListTwo() {
      return [
        { id: 1, name: "不符合" },
        { id: 2, name: "符合" }
      ];
    },
    //   操作人类型
    operaterTypeList() {
      return [
        { id: 0, name: "安全主任" },
        { id: 1, name: "小组长" },
        { id: 2, name: "督察员" }
      ];
    },
    //   操作结果类型
    operaterResultList() {
      return [
        { id: 0, name: "已处理" },
        { id: 1, name: "已审核" },
        { id: 2, name: "已督办" }
      ];
    }
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      let res = await this.$Http.getSpecialInspectionTask(this.requestData);
      if (res.code == 200) {
        // console.log(res);

        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        this.responseData.list = res.data.list;

        // console.log(this.responseData);
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 获取详情
    async getDetailsData(id) {
      var requestData = {
        specialInspectionSchoolId: id
      };
      let res = await this.$Http.getSpecialInspectionTaskDetails(requestData);
      if (res.code == 200) {
        this.dialogTableVisible = true;
        let data = res.data || {};
        this.inspectionDetails = data;
        if (
          data.status == 1 &&
          data.teamer == this.$store.getters.getUserInfo.userId
        ) {
          // 当检查状态为1时可以审核，审核的时候要校验当前登录id和小组长是否为一个人
          this.isEdit = true;
          this.inspectionDetails.schoolChecksList.map((item) => {
            item.teamState = 2;
            return item;
          });
        }
        if (data.status == 0) {
          this.inspectionDetails.schoolChecksList.map((item) => {
            item.internalState = 2;
            return item;
          });
        }
      } else if (res.code == 101) {
        this.inspectionDetails = {};
      } else {
        this.inspectionDetails = {};
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async saveClick() {
      let obj = {
        id: this.inspectionDetails.id,
        schoolChecksList: this.inspectionDetails.schoolChecksList,
        schoolRecordList: []
      };
      if (this.inspectionDetails.status == 0) {
        obj.rummager = this.$store.getters.getUserInfo.userId;
      }
      //   传下一个流程的状态
      if (this.inspectionDetails.status == 0) {
        obj.status = 1;
      } else if (this.inspectionDetails.status == 1) {
        obj.status = 3;
      }
      //   专项检查处理流水记录
      let objc = {
        operateId: this.$store.getters.getUserInfo.userId,
        specialInspectionSchoolId: this.inspectionDetails.id
      };
      if (obj.status == 1) {
        objc.type = 0;
      }
      if (obj.status == 3) {
        objc.type = 1;
      }
      obj.schoolRecordList.push(objc);
      let res = await this.$Http.editInspectionInfo(obj);
      if (res.code == 200) {
        this.$message({
          message: this.inspectionDetails.status == 1 ? "审核成功" : "检查成功",
          type: "success"
        });
        this.dialogTableVisible = false;
        this.getDataList();
      } else {
        this.$message({
          message: this.inspectionDetails.status == 1 ? "审核失败" : "检查失败",
          type: "error"
        });
      }
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getDataList();
      // console.log(`当前页: ${val}`);
    }
  },
  created() {},
  mounted() {
    this.getDataList();
  }
};
</script>
<style lang="scss" scoped>
.detail-dialog {
  .content {
    max-height: 500px;
    overflow: auto;
  }
  .question {
    padding: 10px 0;
    .question-title {
      padding: 10px 10px;
      border: 1px solid #ebeef5;
      border-bottom: none;
    }
    .question-detail {
      padding: 10px 10px;
      border: 1px solid #ebeef5;
    }
  }
}
</style>
